/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */



import { Query } from 'fierry/flux'

import Auth from 'shared/client/auth';
import Url from 'shared/client/url';

import Rpc from 'shared/alias/rpc';
import FakeRpc from 'shared/alias/fake.rpc';


export default new Query([ Rpc, FakeRpc, Auth, Url ], (rpc, fake, auth, url) =>
{
  if (auth.isLoggedOut())
  {
    return fake.getGalaxy(url.getRoute(), url.getArgs());
  }

  if (rpc && auth.isLoggedIn())
  {
    const galaxy = rpc.getGalaxy();

    return (galaxy && galaxy.isReady()) ? galaxy : null;
  }

  return null;
});
